import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Host as MfeHost, HostConfigurationResponse, addFeatureFlagEvaluation } from '@economic/react-app';
import { AppDrawerProvider } from '~/app/components/AppDrawer/AppDrawerContext';
import mixpanelTrack from '~/app/shared/util/utilities/mixpanel';
import { LegacyFrameIntegration } from './app/shared/components/LegacyFrameIntegration';
import getEnvironment from './utilities/getEnvironment';
import pkg from '../package.json';
import { fetchXsrfTokenHeaders } from './utilities/fetchXsrfTokenHeaders';
import Application from './components/Application';
import External from './external';
import tracer from './utilities/trace';

const fetchConfiguration = async () => {
    const fetchConfig = await fetchXsrfTokenHeaders();
    const host = await axios
        .get<HostConfigurationResponse>(`${process.env.ECONOMIC_PATH}/internal-api/mfe/host`, fetchConfig)
        .then(response => response.data);

    return host;
};

const Host = () => {
    const configuration = {
        datadog: {
            applicationId: '89086963-d235-4333-b1d9-2551191bdd05',
            clientToken: 'pub2fd1f64a409d19e7277f19765c95d122',
        },
        fetcher: fetchConfiguration,
    };

    return (
        <AppDrawerProvider>
            <MfeHost
                configuration={configuration}
                environment={getEnvironment()}
                origin={process.env.PUBLIC_URL}
                version={pkg.version}
                onFlagExposed={(name, value) => {
                    tracer.info(`feature:${name} ${value}`);
                    mixpanelTrack('experiments', 'started', {
                        experimentName: name,
                        experimentVariant: value,
                    });
                    addFeatureFlagEvaluation(name, value);
                }}>
                <Application />
            </MfeHost>
            <LegacyFrameIntegration path={process.env.ECONOMIC_PATH ?? ''} />
        </AppDrawerProvider>
    );
};

const router = createBrowserRouter([
    { path: '/external/*', Component: External },
    { path: '*', Component: Host },
]);

const Router = () => {
    return <RouterProvider router={router} />;
};

ReactDOM.render(
    <React.StrictMode>
        <Router />
    </React.StrictMode>,
    document.getElementById('root')
);
